
import type { Tables } from "@/integrations/supabase/types";
import { Tag } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface PropertyPriceProps {
  property: Tables<"real_estate_properties">;
}

export const PropertyPrice = ({ property }: PropertyPriceProps) => {
  return (
    <div className="mb-4">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-2xl font-bold text-green-700">GHS {property.price.toLocaleString()}</p>
          {property.collateral_value && (
            <div className="flex items-center mt-1">
              <Tag className="h-3 w-3 mr-1 text-purple-600" />
              <p className="text-xs text-purple-600 font-medium">
                Use as collateral for loans up to GHS {property.collateral_value.toLocaleString()}
              </p>
            </div>
          )}
        </div>
        
        {property.status === 'available' && (
          <Badge className="bg-green-500">Available Now</Badge>
        )}
      </div>
      
      {property.expected_returns && (
        <div className="mt-2 py-1 px-2 bg-amber-50 border border-amber-100 rounded text-xs text-amber-700">
          Property value expected to grow by {property.expected_returns}% annually
        </div>
      )}
    </div>
  );
};
